module.exports = __webpack_public_path__ + "img/fachadaeliza1.81b90755.png";